import React from "react";
import { withRouter, NavLink } from "react-router-dom";

import backArrow from "../../assets/svg/back_arrow.svg";

import "./styles.scss";

class Header extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            positionY: 0,
        };
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = (event: any) => {
        this.setState({ positionY: window.pageYOffset });
    };

    handleOnClickLogo() {}

    render() {
        const { positionY } = this.state;

        console.log("props", this.props.location.pathname);

        const alwaysReverse = this.props.location.pathname === "/step3";

        return (
            <div
                className="HeaderMainWrapper"
                style={{
                    backgroundColor: positionY > 50 || alwaysReverse ? "#734578" : "transparent",
                    WebkitBoxShadow: positionY > 50 || alwaysReverse ? "0px 24px 35px -26px rgba(0, 0, 0, 0.75)" : "",
                    MozBoxShadow: positionY > 50 || alwaysReverse ? "0px 24px 35px -26px rgba(0, 0, 0, 0.75)" : "",
                    boxShadow: positionY > 50 || alwaysReverse ? "0px 24px 35px -26px rgba(0, 0, 0, 0.75)" : "",
                }}
            >
                {this.props.location.pathname !== "/" && <img className="BackButton" src={backArrow} onClick={() => this.props.history.push("/")} />}
                <NavLink exact className="HeaderHeader" to="/">
                    communitypool
                </NavLink>
            </div>
        );
    }
}

export default withRouter(Header);
